import { 
  IonRow,
  IonGrid,
} from '@ionic/react';

import {
  useJsApiLoader,
  GoogleMap,
  DirectionsRenderer
} from '@react-google-maps/api'
import { useEffect , useState} from 'react';
import { GlobalStore } from "../../../store/GlobalStore";
import { useRecoilState } from "recoil";
import { oldBookingState } from "../../../store/atoms"

import '../../../styles/NewDeliveryComponent.css'
import '../../../styles/style.css'

const center = {
  lat: 1.3521,
  lng: 103.8198
};

const mapContainerStyle = {
  width: '100%',
  height: '350px',

};


function MapComponent (props){

  const [directionsResponse, setDirectionsResponse] = useState(null)
  const [distance, setDistance] = useState('')
  const [duration, setDuration] = useState('')

  // const [oldBooking, setOldBooking] = useRecoilState(oldBookingState)

    const { isLoaded, loadError } = useJsApiLoader({
      googleMapsApiKey: process.env.REACT_APP_GOOGLEMAP_API_KEY,
    })

    useEffect(()=>{
      
      if (Object.keys(props.deliveryAddresses.pickUpLocation ).length !== 0
         && Object.keys(props.deliveryAddresses.dropOffLocation ).length !== 0) {
           const generatedPlaces = generatePlacesFromDeliveryAddress(props.deliveryAddresses)
         calculateRoute(generatedPlaces)
      }

    },[props.deliveryAddresses])
  
  const generatePlacesFromDeliveryAddress = (oldBooking) => {
    let places = []
    
    let pickupLocation = {
      latitude :oldBooking.pickUpLocation.latitude,
      longitude : oldBooking.pickUpLocation.longitude
    }
    places.push(pickupLocation)

    let dropOffLocation = {
      latitude :oldBooking.dropOffLocation.latitude,
      longitude : oldBooking.dropOffLocation.longitude
    }
    places.push(dropOffLocation)

    for (let address of oldBooking.additionalStops) {
      if(address) {
        let latlngData = {
          latitude :address.latitude,
          longitude : address.longitude
        }
        places.push(latlngData)
      }
        
    }
    return places
  }
  const calculateRoute = async (places) => {

    const waypoints = places.map(p => ({
      location: { lat: p.latitude, lng: p.longitude },
      stopover: true
    }));
    
    const origin = waypoints.shift().location;
    
    const destination = waypoints.pop().location;
    
    // eslint-disable-next-line no-undef
      const n_start = new google.maps.LatLng(origin.lat,origin.lng)
      
      // eslint-disable-next-line no-undef
      const n_end = new google.maps.LatLng(destination.lat,destination.lng)
      


     // eslint-disable-next-line no-undef
     const directionsService = new google.maps.DirectionsService()
     const results = await directionsService.route({
          origin: n_start,
          destination: n_end,
          // eslint-disable-next-line no-undef
          travelMode: google.maps.TravelMode.DRIVING,
          waypoints: waypoints
    })
    setDirectionsResponse(results)
    
    setDistance(results.routes[0].legs[0].distance.text)
    
    setDuration(results.routes[0].legs[0].duration.text)
    
    
  }

  if (!isLoaded) {
      return (
        <div className='summary'>
            <IonGrid>
              <IonRow>
                
              <p>Google Loading Error!!!</p>
            
              </IonRow>
            </IonGrid>
            
          </div>
      )
  } else {
    // calculateRoute()
  }

  return (
      <>
          <div className='summary'>
            <IonGrid>
              <IonRow>
                <GoogleMap
                    center={center}
                    zoom={10}
                    mapContainerStyle={mapContainerStyle}
                    options={{
                      zoomControl: false,
                      streetViewControl: false,
                      mapTypeControl: false,
                      fullscreenControl: false,
                    }}
                > 
                {directionsResponse && (
                  <DirectionsRenderer directions={directionsResponse} />
                )}



                </GoogleMap>
  
            
              </IonRow>
            </IonGrid>
            
          </div>
      </>
  )
}

export default MapComponent;